// ============================================================================
// accesInstances.js — QUI voit les documents d'une instance (côté affichage)
// ============================================================================
//
// Miroir EXACT de assertAccesInstances (functions/sharepoint.js), la règle
// Pierre du 26/08/2026 : « seuls les mandataires EN COURS ont accès aux
// instances et dossiers dont ils sont mandataires ; les présidents (PR), les
// DG et les membres du CODIR (CD) ont droit à tous les accès ». Le Bureau se
// juge sur ses titulaires (gouvernance.postesActifs), pas sur un rôle. Les
// « Documents communs » s'ouvrent à tout mandataire d'une instance.
//
// Ici c'est l'AFFICHAGE (montrer la bibliothèque ou l'encart « réservé ») ;
// le DROIT reste côté serveur. Les deux doivent dire la même chose, sinon un
// membre voit un cadenas là où le serveur l'aurait laissé passer — c'est
// arrivé le 03/09/2026 : les gates Gouvernance lisaient `aramisSession.roles`,
// un INSTANTANÉ pris à la connexion, alors que le serveur lit la fiche
// `delegates` à jour. Un rôle CA coché après la dernière connexion du membre
// restait invisible côté front jusqu'à sa déconnexion.
//
// Source des rôles : la fiche annuaire (delegates) d'abord, la session en
// repli — même choix que evaluateViewAccess (App.jsx).
// ============================================================================

const ROLES_ACCES_GLOBAL = ["PR", "DG", "CD"];

export const estAdminSession = (session) =>
  !!session && (session.role === "admin" || session.role === "superadmin");

/** Rôles EFFECTIFS d'un membre : fiche annuaire à jour, session en repli. */
export function rolesEffectifs(session, delegates = []) {
  if (!session) return [];
  const me = Array.isArray(delegates) ? delegates.find((d) => d && d.id === session.id) : null;
  const src = me && Array.isArray(me.roles) ? me.roles : session.roles;
  return Array.isArray(src) ? src : [];
}

/** Titulaire d'un poste du Bureau (postesActifs), quel que soit son rôle. */
export function estTitulaireBureau(session, gouvernance = {}) {
  if (!session || !session.id) return false;
  return ((gouvernance && gouvernance.postesActifs) || [])
    .some((p) => p && p.membreId === session.id);
}

/**
 * Peut-on ouvrir les documents d'un périmètre ?
 * scope : "CA" | "AG" | "CODIR" | "BUREAU" | "COMMUN"
 */
export function peutVoirDocsInstance(scope, session, delegates = [], gouvernance = {}) {
  if (!session) return false;
  if (estAdminSession(session)) return true;
  const roles = rolesEffectifs(session, delegates);
  if (ROLES_ACCES_GLOBAL.some((r) => roles.includes(r))) return true;
  switch (String(scope || "").toUpperCase()) {
    case "CA": return roles.includes("CA");
    case "AG": return roles.includes("AG");
    case "BUREAU": return estTitulaireBureau(session, gouvernance);
    case "CODIR": return false; // PR/DG/CD déjà passés
    case "COMMUN":
      return roles.includes("CA") || roles.includes("AG") || estTitulaireBureau(session, gouvernance);
    default: return false;
  }
}

/** Périmètres accessibles à un membre — sert à l'orienter (page Instances). */
export function perimetresAccessibles(session, delegates = [], gouvernance = {}) {
  return ["CA", "AG", "CODIR", "BUREAU", "COMMUN"]
    .filter((s) => peutVoirDocsInstance(s, session, delegates, gouvernance));
}
